import axios from "axios";
import { buildApiUrl } from "../config/api";

export const FORM3_MIN_SUBJECTS = 8;

/** Form 3 and Form 4 require the same ≥8 subject line at enrollment. */
export function isSubjectChoiceFormLevel(formLevel) {
    return formLevel === "Form 3" || formLevel === "Form 4";
}

export async function fetchForm3SelectionStatus(studentId, classId) {
    const params = classId ? { classId } : {};
    const { data } = await axios.get(buildApiUrl(`/Form3SubjectSelection/status/${studentId}`), { params });
    return data;
}

export async function submitForm3SubjectSelection(studentId, { classId, subjectIds, academicYear }) {
    const { data } = await axios.post(buildApiUrl(`/Form3SubjectSelection/submit/${studentId}`), {
        classId,
        subjectIds,
        academicYear,
    });
    return data;
}

function formatForm3ApiError(error, fallback) {
    const data = error?.response?.data;
    return (
        data?.message ||
        data?.error ||
        (typeof data === "string" ? data : null) ||
        error?.message ||
        fallback
    );
}

export async function setForm3SubjectSelectionOpen(classId, open) {
    try {
        const { data } = await axios.put(buildApiUrl(`/Form3SubjectSelection/class/${classId}/open`), {
            open,
        });
        return data;
    } catch (error) {
        const msg = formatForm3ApiError(error, "Could not update Form 3 subject selection.");
        const wrapped = new Error(msg);
        wrapped.response = error.response;
        throw wrapped;
    }
}
